module.exports = __webpack_public_path__ + "img/book-002.1798c818.jpg";